function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M-804-1330h1920V713H-804z"
}), React.createElement("path", {
  d: "M-804-1034h1920V636H-804z"
}), React.createElement("g", {
  transform: "translate(-69.5 -52)"
}, React.createElement("path", {
  d: "M95.066 87.076a10.68 10.68 0 0 1 9.036 2.834l3.364 3.197a4.074 4.074 0 0 0 6.12-.583l.065-.09a4.5 4.5 0 0 1 7.41.132h-.001l6.21 9.37a1.067 1.067 0 1 1-1.778 1.179l-6.21-9.37a2.334 2.334 0 0 0-1.93-1.057 2.335 2.335 0 0 0-1.966.989l-.064.09a6.207 6.207 0 0 1-9.326.887l-3.364-3.197a8.56 8.56 0 0 0-7.242-2.271 8.56 8.56 0 0 0-6.23 4.337l-7.53 13.574h48.49a1.067 1.067 0 0 1 0 2.134H79.816a1.067 1.067 0 0 1-.933-1.584l8.41-15.16a10.68 10.68 0 0 1 7.772-5.41zm24.153 15.54a1.094 1.094 0 1 1 0 2.187 1.094 1.094 0 0 1 0-2.187zm-28.438-2.188a1.094 1.094 0 1 1 0 2.188 1.094 1.094 0 0 1 0-2.188zm15.313 0a1.094 1.094 0 1 1 0 2.188 1.094 1.094 0 0 1 0-2.188zm-6.563-2.187a1.094 1.094 0 1 1 0 2.187 1.094 1.094 0 0 1 0-2.187zm15.313 0a1.094 1.094 0 1 1 0 2.187 1.094 1.094 0 0 1 0-2.187zm-19.688-4.375a1.094 1.094 0 1 1 0 2.187 1.094 1.094 0 0 1 0-2.187z",
  fill: "currentColor"
})), React.createElement("text", {
  fontFamily: "BNPPSans, BNPP Sans",
  fontSize: 16,
  transform: "translate(-69.5 -56.72)"
}, React.createElement("tspan", {
  x: 82.8,
  y: 138.719
}, "Piasek")));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 71,
    height: 71
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/piasek.595e76b5.svg";
export { SvgComponent as ReactComponent };